// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as ExpandComponent} from './Expand.svg';

import Icon, { TIconProps } from '../Icon';

export const IconExpand = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <ExpandComponent/>
  </Icon>
));
